import moment from 'moment';
import { FC, useState } from 'react';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';
import { useVisitsService } from '../../../../../../hooks/use-visits-service';
import { PatientAppointment } from '../../../../../../services/appointment/types';
import { PastAppointmentItem } from '../../../../../shared/appointment/past-appointment-item';
import { UpcomingAppointmentItem } from '../../../../../shared/appointment/upcoming-appointment-item';
import { NoDataComponent } from '../../../../../shared/grid/no-data';
import { PatientProfileHeader } from '../../header/header';
import { QuickNavMenu } from '../../header/quick-nav-menu/quick-nav-menu';
import { LiSeparator, List } from '../../patient-profile-widget.styles';
import { ViewContent } from '../shared/view-content/view-content';
import { ProceduresDialog } from './procedures-dialog/procedures-dialog';
import { VisitsSkeleton } from './visits.skeleton';

export const VisitsView: FC = () => {
  const { contactDetails, locationId } = usePatientProfile();
  const [selectedItem, setSelectedItem] = useState<PatientAppointment>();
  const [dialogOpened, setDialogOpened] = useState(false);

  const { appointments, isLoading } = useVisitsService(contactDetails?.id, locationId);

  const handleItemClick = (appointment: PatientAppointment) => {
    setSelectedItem(appointment);
    setDialogOpened(true);
  };

  const handleDialogClose = async () => {
    setDialogOpened(false);
    setSelectedItem(undefined);
  };

  const upcomingAppointmentItem = (appointment: PatientAppointment) => {
    return (
      <UpcomingAppointmentItem
        key={appointment.id}
        appointment={appointment}
        onClick={() => handleItemClick(appointment)}
      />
    );
  };

  const pastAppointmentItem = (appointment: PatientAppointment) => {
    return (
      <PastAppointmentItem
        key={appointment.id}
        appointment={appointment}
        onClick={() => handleItemClick(appointment)}
      />
    );
  };

  return (
    <>
      <PatientProfileHeader />
      <QuickNavMenu />
      <ViewContent>
        {isLoading && <VisitsSkeleton />}
        {!isLoading && appointments.length === 0 && <NoDataComponent />}
        {!isLoading && appointments.length > 0 && (
          <>
            <List>
              {appointments.map((appt, index) => {
                return (
                  <>
                    {moment(appt.date).isBefore(moment()) ? pastAppointmentItem(appt) : upcomingAppointmentItem(appt)}
                    {index !== appointments.length - 1 && <LiSeparator key={1000 + index} />}
                  </>
                );
              })}
            </List>
          </>
        )}
      </ViewContent>
      {selectedItem && (
        <ProceduresDialog isOpen={dialogOpened} appointment={selectedItem} onClose={handleDialogClose} />
      )}
    </>
  );
};
